// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1Irwh","list":"PatternAutocomplete_list__3rJnX"};